import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import {ElementoCarro} from '../../../../model/interface/ElementoCarro';
import {ICertificacion} from '../../../../model/interface/ICertificacion';
import {Archivo} from '../../../../model/class/Archivo';
import {Documento} from '../../../../model/class/Documento';
import {PreviewProductService} from '../../../services/preview-product/preview-product.service';
import {NgxGalleryImage, NgxGalleryOptions} from 'ngx-gallery';
import {CodigoProducto} from '../../../../model/class/CodigoProducto';
import {Producto} from '../../../../model/class/Producto';

@Component({
  selector: 'app-preview-producto',
  templateUrl: './preview-producto.component.html',
  styleUrls: ['./preview-producto.component.css'],
  animations: [

    trigger('visibility-codes', [
      state('in', style({
        'opacity': '1',
        'display': 'visible',
      })),
      state('out', style({
        'opacity': '0',
        'display': 'none',
      })),
      transition('in => out', animate('300ms ease-in')),
      transition('out => in', animate('300ms ease-out'))
    ])
  ]
})
export class PreviewProductoComponent implements OnInit {

  producto: any = {marca: {}};
  categorias: any[] = [];
  colores: any[] = [];
  codigos: CodigoProducto[] = [];
  certificaciones: ICertificacion[];
  complementarios: Producto[] = [];
  relacionados: Producto[] = [];
  tablaVertical = true;

  archivosGaleria: Archivo[] = [];
  archivosDescargables: any[] = [];

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];

  statusCodes = 'out';
  viewEctraCol = false;

  loadres = {
    producto: true
  };

  slideConfig = {'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': false, 'dots': true};

  constructor(
    private previewProductService: PreviewProductService
  ) { }

  ngOnInit() {
    this.producto = this.previewProductService.producto;
    if (this.producto.especificaciones.caracteristicas) {
      for (const cat of this.producto.especificaciones.caracteristicas) {
        if (cat.otro && cat.otro !== '') {
          this.viewEctraCol = true;
        }
      }
    }

    if (!this.producto.especificaciones.esVertical) {
      this.tablaVertical = false;
    }

    if (this.previewProductService.categorias) {
      this.categorias = this.previewProductService.categorias;
    }
    if (this.previewProductService.colores) {
      this.colores = this.previewProductService.colores;
    }
    if (this.previewProductService.codigos) {
      this.codigos = this.previewProductService.codigos;
    }
    if (this.previewProductService.productosComplementarios) {
      this.complementarios = this.previewProductService.productosComplementarios;
    }
    if (this.previewProductService.productosRelacionados) {
      this.relacionados = this.previewProductService.productosRelacionados;
    }
    if (this.previewProductService.archivosGaleria) {
      this.archivosGaleria = this.previewProductService.archivosGaleria;
    }
    if (this.previewProductService.archivosDescargables) {
      this.archivosDescargables = this.previewProductService.archivosDescargables;
    }

    if (this.previewProductService.certificaciones) {
      this.certificaciones = _.filter(this.previewProductService.certificaciones, {selected: true});
    }

    for (const imagen of this.previewProductService.imagenesProducto) {
      const auxImg = {
        small: imagen.url,
        medium: imagen.url,
        big: imagen.url,
      };

      this.galleryImages.push(auxImg);
    }






  }

  verCodigos() {
    this.statusCodes = this.statusCodes === 'out' ? 'in' : 'out';
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/preview-producto/preview-producto.component.ts